import { HttpMethodEnum } from 'submodules/nerit-framework-utils/sdk-utils/request-manager/enums/HttpMethodEnum'
import { RequestConfigTP } from 'submodules/nerit-framework-utils/sdk-utils/request-manager/types/RequestConfigTP'
import { UserLoginRequestDTO } from 'submodules/nerit-aquatec-sdk/services/auth/dtos/requests/UserLoginRequestDTO'
import { AquatecSystemApiEnum } from 'submodules/nerit-aquatec-sdk/common/AquatecSystemApiEnum'
import { RecoverAccessRequestDTO } from './dtos/requests/RecoverAccessRequestDTO'

export class AuthRequests {

	public static CONTROLLER_ROOT = 'auth'
	public static LOGIN_EP = 'login'
	public static GENERATE_CLIENT_TOKEN_EP = 'generate'
	public static RECOVER_ACCESS_EP = 'recover-access'
	
	static login = (dto: UserLoginRequestDTO): RequestConfigTP => ({
		baseUrlType: AquatecSystemApiEnum.AQUATEC_API,
		url: `${AuthRequests.CONTROLLER_ROOT}/${AuthRequests.LOGIN_EP}`,
		method: HttpMethodEnum.POST,
		params: dto
	})

	static recoverAccess = (dto: RecoverAccessRequestDTO): RequestConfigTP<void> => ({
		baseUrlType: AquatecSystemApiEnum.AQUATEC_API,
		url: `${AuthRequests.CONTROLLER_ROOT}/${AuthRequests.RECOVER_ACCESS_EP}`,
		method: HttpMethodEnum.POST,
		params: dto
	})

}
